module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Hanger-9823aea88b52db9035c3c0c8052aaad3.svg";